import styles from "../Indicator.module.css";
import { useState } from "react";
import { Slider } from "../ui/slider";
import { Input } from "../ui/input";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "../ui/button";
import {
  selectContainer,
  setCustomContainer,
} from "src/lib/slices/drinkSelectionSlice";

export default function CustomContainer({ setOpen }) {
  const customContainer = useSelector(
    (state: any) => state.drinkSelection.customContainer
  );
  const dispatch = useDispatch();

  const [value, setValue] = useState(customContainer.volume);
  const maxValue = 1000;
  const percentageOfMax = Math.min((value / maxValue) * 100, 100);

  const select = () => {
    dispatch(setCustomContainer({ volume: value }));
    dispatch(selectContainer("Own"));
    setOpen(false);
  };

  return (
    <div style={{ height: "100%" }}>
      <div
        style={{
          marginBottom: "1rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "1ch",
        }}
      >
        <Input
          style={{ maxWidth: "20ch" }}
          type="number"
          value={value}
          onChange={(e) => setValue(Math.abs(+e.target.value || 0))}
        />
        <div style={{ fontStyle: "italic" }}>ml</div>
      </div>
      <div
        style={{
          height: "calc(100% - 8.5rem)",
          maxWidth: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            height: "100%",
            display: "flex",
            maxWidth: "100%",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "100%",
              height: "100%",
              maxWidth: "fit-content",
              minWidth: "fit-content",
              aspectRatio: "130 / 150",
            }}
          >
            <img
              src="/images/beer-empty.svg"
              style={{ height: "100%", zIndex: "1", position: "relative" }}
              alt=""
            />
            <div
              style={{
                position: "absolute",
                width: "61%",
                height: `70%`,
                bottom: "5.5%",
                left: "6%",
                display: "flex",
                alignItems: "flex-end",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: `${percentageOfMax}%`,
                  backgroundColor: "#efb541",
                }}
                className={styles["status-bar"]}
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          paddingTop: "1rem",
          height: "2rem",
          display: "flex",
          alignItems: "center",
        }}
        data-vaul-no-drag
      >
        <Slider
          style={{
            width: "100%",
          }}
          max={maxValue}
          step={10}
          value={[value]}
          onValueChange={([value]) => setValue(value)}
        />
      </div>
      <div
        style={{
          paddingTop: "1rem",
          display: "flex",
          justifyContent: "center",
        }}
        onClick={select}
      >
        <Button>Vybrat</Button>
      </div>
    </div>
  );
}
